// import Swal from 'sweetalert2/dist/sweetalert2.js';

// export const Notify = (type, msg, title) => {
//   if (type === 'error') {
//     Swal.fire({
//       title: title,
//       text: msg,
//       icon: type,
//       confirmButtonText: 'Okay',
//       //  zIndex: 60000   // أعلى من المودال
//     });
//   } else if (type === 'success') {
//     Swal.fire({
//       position: 'center center',
//       icon: type,
//       text: msg,
//       title: title,
//       showConfirmButton: false,
//       timer: 1500,
//       // target: , // جرب Body أولاً
//     });
//   } else if (type === 'warning') {
//     Swal.fire({
//       title: title,
//       text: msg,
//       icon: type,
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Swal.fire({
//           title: 'Deleted!',
//           text: 'Your file has been deleted.',
//           icon: 'success',
//         });
//       }
//     });
//   }
// };









import toast from 'react-hot-toast';

/* ════════════════════════════════════════════════════════════════════
   NOTIFY  —  same API: Notify(type, msg, title)
   types: 'success' | 'error' | 'warning' | 'info'
════════════════════════════════════════════════════════════════════ */

const TYPES = ['success', 'error', 'warning', 'info'];

/* ── unified brand color ── */
const BRAND     = '#FFB300';
const BRAND_BG  = '#0F172A';   // داكن شيك
const BRAND_ICO = '#1E293B';   // دايرة الأيقونة

/* ── duration ── */
const duration = {
  success : 2500,
  error   : 4500,
  warning : 4000,
  info    : 3000,
};

/* ── SVG icons ── */
const SvgIcon = ({ type }) => {
  const stroke = BRAND;
  const paths = {
    success: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6L9 17l-5-5"/>
      </svg>
    ),
    error: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    ),
    warning: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    ),
    info: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    ),
  };
  return paths[type] || paths.info;
};

/* ── inject keyframes once ── */
if (!document.getElementById('__notify-keyframes')) {
  const s = document.createElement('style');
  s.id = '__notify-keyframes';
  s.innerHTML = `
    @keyframes __notify-slide-in {
      from { opacity: 0; transform: translateX(60px) scale(0.92); }
      to   { opacity: 1; transform: translateX(0)   scale(1);    }
    }
    @keyframes __notify-slide-out {
      from { opacity: 1; transform: translateX(0)   scale(1);    }
      to   { opacity: 0; transform: translateX(60px) scale(0.92); }
    }
    @keyframes __notify-icon-pop {
      0%   { transform: scale(0.5) rotate(-15deg); opacity: 0; }
      60%  { transform: scale(1.2) rotate(5deg);  opacity: 1; }
      100% { transform: scale(1)   rotate(0deg);  opacity: 1; }
    }
    @keyframes __notify-progress {
      from { width: 100%; }
      to   { width: 0%; }
    }
  `;
  document.head.appendChild(s);
}

/* ════════════════════════════════════════════════════════════════════ */
export const Notify = (type = 'info', msg = '', title = '') => {
  const safeType     = TYPES.includes(type) ? type : 'info';
  const displayTitle = title && !TYPES.includes(title) ? title : null;
  const dur          = duration[safeType] || 3000;

  return toast.custom(
    (t) => (
      <div
        onClick={() => toast.dismiss(t.id)}
        style={{
          fontFamily   : "'DM Sans', system-ui, sans-serif",
          display      : 'flex',
          alignItems   : 'flex-start',
          gap          : '12px',
          background   : BRAND_BG,
          color        : '#F8FAFC',
          border       : `1.5px solid ${BRAND}30`,
          borderLeft   : `3px solid ${BRAND}`,
          borderRadius : '14px',
          padding      : '14px 16px 18px',
          maxWidth     : '360px',
          minWidth     : '280px',
          cursor       : 'pointer',
          position     : 'relative',
          overflow     : 'hidden',
          boxShadow    : `0 4px 24px rgba(0,0,0,0.25), 0 0 0 1px ${BRAND}15`,
          animation    : t.visible
            ? '__notify-slide-in 0.32s cubic-bezier(0.34,1.2,0.64,1) both'
            : '__notify-slide-out 0.22s ease forwards',
          zIndex       : 999999,
        }}
      >
        {/* icon circle */}
        <div style={{
          width          : '34px',
          height         : '34px',
          borderRadius   : '50%',
          background     : BRAND_ICO,
          border         : `1.5px solid ${BRAND}40`,
          display        : 'flex',
          alignItems     : 'center',
          justifyContent : 'center',
          flexShrink     : 0,
          animation      : '__notify-icon-pop 0.45s cubic-bezier(0.34,1.3,0.64,1) 0.1s both',
        }}>
          <SvgIcon type={safeType} />
        </div>

        {/* text */}
        <div style={{ flex: 1, paddingTop: '1px' }}>
          {displayTitle && (
            <div style={{ fontWeight: 700, fontSize: '14px', lineHeight: 1.3, marginBottom: '3px', color: BRAND }}>
              {displayTitle}
            </div>
          )}
          {msg && (
            <div style={{ fontWeight: 500, fontSize: '13px', lineHeight: 1.5, color: '#CBD5E1' }}>
              {msg}
            </div>
          )}
        </div>

        {/* progress bar */}
        <div style={{
          position     : 'absolute',
          bottom       : 0,
          left         : 0,
          height       : '3px',
          borderRadius : '0 0 0 14px',
          background   : BRAND,
          opacity      : 0.8,
          animation    : `__notify-progress ${dur}ms linear forwards`,
        }} />
      </div>
    ),
    {
      duration : dur,
      position : 'top-right',
    }
  );
};
